
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/SupabaseAuthContext';
import { clearUserSession } from '@/utils/sessionManager';
import { isSuperAdmin as checkIsSuperAdmin } from '@/utils/userRoleService';

export const useAuthUser = () => {
  const navigate = useNavigate();
  const { user, profile, signOut } = useAuth();
  
  useEffect(() => {
    if (!user) {
      navigate('/auth');
      return;
    }
    
    // Check if user is a super admin
    if (profile && !['superadmin', 'masterAdmin'].includes(profile.role)) {
      navigate('/auth');
      return;
    }
  }, [user, profile, navigate]);

  const handleLogout = async () => {
    console.log("useAuthUser: Starting logout process");
    try {
      // Call Supabase signOut
      await signOut();
      
      // Clear local session data
      clearUserSession();
      
      console.log("useAuthUser: Logout successful");
      
      // Force redirect to auth page
      window.location.href = '/auth';
      
      return true;
    } catch (error) {
      console.error('useAuthUser: Error logging out:', error);
      
      // Still clear session on error
      clearUserSession();
      
      // Force redirect to auth page even on error
      window.location.href = '/auth';
      
      return false;
    }
  };

  return {
    user: profile,
    handleLogout
  };
};
